import React from 'react';
import { bool } from 'prop-types';
import { UTLoading } from '@widergy/energy-ui';

import styles from './styles.module.scss';

const AuthFormWrapper = ({ children, loading }) => (
  <div className={styles.container}>
    <div className={styles.backgroundTop} />
    <div className={styles.backgroundBottom} />
    <UTLoading loading={loading} className={styles.spinner}>
      <div className={styles.formContainer}>{children}</div>
    </UTLoading>
  </div>
);

AuthFormWrapper.propTypes = {
  loading: bool
};

export default AuthFormWrapper;
